<template>
  <div>
    <div class="titles">
      <h1 class="questionTitlee">{{ $t("commonQuestionsTitle") }}</h1>
      <h1 class="questionHeader">
        {{ $t("commonQuestions") }}
      </h1>
    </div>
    <div class="container containerQuestions">
      <div class="accordion">
        <dl>
          <dt>
            <a class="accordionTitle" href="#">{{ $t("q1") }}</a>
          </dt>
          <dd
            :class="{
              'accordionItem accordionItemCollapsed': langVar === 'ar',
              'accordionItem accordionItemCollapsed dd_en': langVar === 'en',
            }"
          >
            <p>
              {{ $t("q1Answer") }}
            </p>
            <ul>
              <li>{{ $t("q1AnswerList1") }}</li>
              <li>{{ $t("q1AnswerList2") }}</li>
            </ul>
          </dd>
          <dt>
            <a href="#" class="accordionTitle">{{ $t("q2") }}</a>
          </dt>
          <dd
            :class="{
              'accordionItem accordionItemCollapsed': langVar === 'ar',
              'accordionItem accordionItemCollapsed dd_en': langVar === 'en',
            }"
          >
            <p>
              {{ $t("q2Answer") }}
            </p>
          </dd>
          <dt>
            <a href="#" class="accordionTitle">{{ $t("q3") }}</a>
          </dt>
          <dd
            :class="{
              'accordionItem accordionItemCollapsed': langVar === 'ar',
              'accordionItem accordionItemCollapsed dd_en': langVar === 'en',
            }"
          >
            <p>
              {{ $t("q3Answer") }}
            </p>
            <ul>
              <li>{{ $t("q3AnswerList1") }}</li>
              <li>{{ $t("q3AnswerList2") }}</li>
              <li>{{ $t("q3AnswerList3") }}</li>
              <li>{{ $t("q3AnswerList4") }}</li>
              <li>{{ $t("q3AnswerList5") }}</li>
              <li>{{ $t("q3AnswerList6") }}</li>
              <li>{{ $t("q3AnswerList7") }}</li>
            </ul>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../store";
import { mapState } from "vuex";
export default {
  data() {
    return {
      langVar: store.state.currentLang,
    };
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      return store.state.currentLang;
    },
  },
  mounted() {
    var accordion = document.querySelector(".accordion");
    accordion.addEventListener("click", function (e) {
      e.stopPropagation();
      e.preventDefault();
      if (e.target && e.target.nodeName == "A") {
        var classes = e.target.className.split(" ");
        if (classes) {
          for (var x = 0; x < classes.length; x++) {
            if (classes[x] == "accordionTitle") {
              var title = e.target;
              var content = e.target.parentNode.nextElementSibling;
              title.classList.toggle("accordionTitleActive");
              if (content.classList.contains("accordionItemCollapsed")) {
                if (content.classList.contains("animateOut")) {
                  content.classList.remove("animateOut");
                }
                content.classList.add("animateIn");
              } else {
                content.classList.remove("animateIn");
                content.classList.add("animateOut");
              }
              content.classList.toggle("accordionItemCollapsed");
            }
          }
        }
      }
    });
  },
};
</script>

<style>
.dd_en {
  text-align: left;
}
.dd_en > ul > li {
  direction: ltr;
}
.titles {
  background-image: url(../../assets/images/background.png);
  background-size: cover;
}
.questionTitlee {
  font-size: 2.5em;
  font-weight: 800;
  padding-top: 3em;
  text-align: center;
  color: #fdc948;
}

.questionHeader {
  font-size: 2em;
  padding-top: 0.5em;
  padding-bottom: 1em;
  text-align: center;
  color: #8d8a87;
}

.accordion dt > a {
  text-align: center;
  font-weight: 700;
  padding: 2em;
  display: block;
  text-decoration: none;
  color: #fff;
  -webkit-transition: background-color 0.5s ease-in-out;
}
.accordion dd {
  background-color: #b5aaa3;
  color: #fafafa;
  font-size: 1em;
  line-height: 1.5em;
}
.accordion dd > p {
  padding: 1em 2em 0em 2em;
}

.accordion dd > ul {
  padding: 0em 5em 1em 2em;
}

.accordion {
  position: relative;
  background-color: #ede8e3;
}

.containerQuestions {
  max-width: 960px;
  margin: 0 auto;
  padding: 2em 0 2em 0;
}

.accordionTitle {
  background-color: #8d8a87;
  border-bottom: 1px solid #797775;
}
.accordionTitle:before {
  content: "+";
  font-size: 1.5em;
  line-height: 0.5em;
  float: left;
  -moz-transition: -moz-transform 0.3s ease-in-out;
  -o-transition: -o-transform 0.3s ease-in-out;
  -webkit-transition: -webkit-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out;
}
.accordionTitle:hover {
  background-color: #797775;
}

.accordionTitleActive {
  background-color: #797775;
}
.accordionTitleActive:before {
  -webkit-transform: rotate(-225deg);
  -moz-transform: rotate(-225deg);
  transform: rotate(-225deg);
}

.accordionItem {
  height: auto;
  overflow: hidden;
}
@media all {
  .accordionItem {
    max-height: 50em;
    -moz-transition: max-height 1s;
    -o-transition: max-height 1s;
    -webkit-transition: max-height 1s;
    transition: max-height 1s;
  }
}
@media screen and (min-width: 48em) {
  .accordionItem {
    max-height: 26em;
    -moz-transition: max-height 0.5s;
    -o-transition: max-height 0.5s;
    -webkit-transition: max-height 0.5s;
    transition: max-height 0.5s;
  }
}

.accordionItemCollapsed {
  max-height: 0;
}

.animateIn {
  -webkit-animation-name: accordionIn;
  -webkit-animation-duration: 0.65s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-direction: normal;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: both;
  -webkit-animation-delay: 0s;
  -moz-animation-name: normal;
  -moz-animation-duration: 0.65s;
  -moz-animation-iteration-count: 1;
  -moz-animation-direction: alternate;
  -moz-animation-timing-function: ease-in-out;
  -moz-animation-fill-mode: both;
  -moz-animation-delay: 0s;
  animation-name: accordionIn;
  animation-duration: 0.65s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-timing-function: ease-in-out;
  animation-fill-mode: both;
  animation-delay: 0s;
}

.animateOut {
  -webkit-animation-name: accordionOut;
  -webkit-animation-duration: 0.75s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-direction: alternate;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: both;
  -webkit-animation-delay: 0s;
  -moz-animation-name: accordionOut;
  -moz-animation-duration: 0.75s;
  -moz-animation-iteration-count: 1;
  -moz-animation-direction: alternate;
  -moz-animation-timing-function: ease-in-out;
  -moz-animation-fill-mode: both;
  -moz-animation-delay: 0s;
  animation-name: accordionOut;
  animation-duration: 0.75s;
  animation-iteration-count: 1;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;
  animation-fill-mode: both;
  animation-delay: 0s;
}

@-webkit-keyframes accordionIn {
  0% {
    opacity: 0;
    -webkit-transform: scale(0.8);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale(1);
  }
}
@-moz-keyframes accordionIn {
  0% {
    opacity: 0;
    -moz-transform: scale(0.8);
  }
  100% {
    opacity: 1;
    -moz-transform: scale(1);
  }
}
@keyframes accordionIn {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@-webkit-keyframes accordionOut {
  0% {
    opacity: 1;
    -webkit-transform: scale(1);
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(0.8);
  }
}
@-moz-keyframes accordionOut {
  0% {
    opacity: 1;
    -moz-transform: scale(1);
  }
  100% {
    opacity: 0;
    -moz-transform: scale(0.8);
  }
}
@keyframes accordionOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}
</style>

<script>
import store from "../../store";
import { mapState } from "vuex";
export default {
  data() {
    return {
      langVar: store.state.currentLang,
    };
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      return store.state.currentLang;
    },
  },
  mounted() {
    var accordion = document.querySelector(".accordion");
    accordion.addEventListener("click", function (e) {
      e.stopPropagation();
      e.preventDefault();
      if (e.target && e.target.nodeName == "A") {
        var classes = e.target.className.split(" ");
        if (classes) {
          for (var x = 0; x < classes.length; x++) {
            if (classes[x] == "accordionTitle") {
              var title = e.target;
              var content = e.target.parentNode.nextElementSibling;
              title.classList.toggle("accordionTitleActive");
              if (content.classList.contains("accordionItemCollapsed")) {
                if (content.classList.contains("animateOut")) {
                  content.classList.remove("animateOut");
                }
                content.classList.add("animateIn");
              } else {
                content.classList.remove("animateIn");
                content.classList.add("animateOut");
              }
              content.classList.toggle("accordionItemCollapsed");
            }
          }
        }
      }
    });
  },
};
</script>
